import { UserAuth } from "@/business/auth/domain/login";
import { manageCookies } from "@/business/shared/session/infrastructure/utils/manageCookies";

export const saveDataMemoryService = {
  async execute(userAuth: UserAuth | null): Promise<void> {
    const date = new Date();
    const expirationTimeInMilliseconds = 60 * 60 * 1000;
    const localExpirationTime = date.getTime() + expirationTimeInMilliseconds;
    const dateExpire = new Date(localExpirationTime).toUTCString();

    const saveUserAuthTransaction =
      userAuth !== null
        ? await this.saveUserAuth(userAuth, dateExpire)
        : await Promise.resolve();

    await Promise.all([saveUserAuthTransaction]);
  },

  async saveUserAuth(userAuth: UserAuth, expire: string): Promise<void> {
    manageCookies.set("userAuth", JSON.stringify(userAuth), expire);
  },
};
